
export const InitialAttachmentsDict = {
    PrzeniesienieWZ: {
        zgoda: {
            label: 'Zgoda strony, dla której została wydana decyzja o warunkach zabudowy, na jej przeniesienie na rzecz innego podmiotu.',
            required: true,
            multiple: false,
            description: '',
        },
        pelnomocnictwo: {
            label: 'Dokument stwierdzający udzielenie pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
    },
    ZmianaWZ: {
        zgoda: {
            label: 'Zgoda stron na zmianę decyzji o warunkach zabudowy (jeśli jest wymagana).',
            required: false,
            multiple: false,
            description: '',
        },
        pelnomocnictwo: {
            label: 'Dokument pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
        pelnomocnictwoOplata: {
            label: 'Dowód uiszczenia opłaty skarbowej z tytułu udzielenia pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
        inne: {
            label: 'Inne załączniki (jeśli są wymagane).',
            required: false,
            multiple: true,
            description: '',
        },
    },
    WnOpiniaPodzialu: {
        tytul: {
            label: 'Dokument stwierdzający tytuł prawny do nieruchomości.',
            required: true,
            multiple: false,
            description: '',
        },
        wypis: {
            label: 'Wypis z katastru nieruchomości i kopię mapy katastralnej obejmującej nieruchomość podlegającą podziałowi.',
            required: true,
            multiple: false,
            description: '',
        },
            projekt: {
            label: 'Wstępny projekt podziału nieruchomości.',
            required: true,
            multiple: false,
            description: '',
        },
            pelnomocnictwo: {
            label: 'Kopia prawomocnej decyzji o warunkach zabudowy i zagospodarowania terenu (jeśli dotyczy).',
            required: false,
            multiple: false,
            description: '',
        },
    },
    ZgloszenieUsunieciaDrzew: {
        mapa: {
            label: 'Rysunek bądź inna mapa określająca usytuowanie drzewa na nieruchomości - szt. 1',
            required: true,
            multiple: false,
            description: '',
        },
        zgody: {
            label: 'W przypadku gdy nieruchomość stanowi współwłasność – zgoda wszystkich współwłaścicieli na usunięcie drzew.',
            required: true,
            multiple: true,
            description: '',
        },
    },
    UstaleniePomnikaOchronyPrzyrody: {
        mapa: {
            label: 'Dokładny szkic umożliwiający odnalezienie pomnika w terenie (wymagany)',
            required: true,
            multiple: false,
            description: 'Możliwe jest zaznaczenie pomnika na mapie (przycisk "Zaznacz punkt na mapie"), a następnie wygenerowanie wydruku z mapy (przycisk "Wygeneruj załącznik").',
        },
        fotografie: {
            label: 'Dokumentacja fotograficzna (niewymagana)',
            required: true,
            multiple: true,
            description: '',
        },
        zgody: {
            label: 'Ewentualna zgoda pisemna właściciela działki na której znajduje się przedmiot ochrony (niewymagana)',
            required: true,
            multiple: false,
            description: '',
        },
    },
    UsuniecieDrzewGminnych: {
        mapa: {
            label: 'Rysunek lub mapa określająca usytuowanie drzew lub krzewu w stosunku do granic nieruchomości i obiektów budowlanych istniejących lub budowanych na tej nieruchomości',
            required: true,
            multiple: false,
            description: 'Możliwe jest zaznaczenie pomnika na mapie (przycisk "Zaznacz drzewo/krzew"), a następnie wygenerowanie wydruku z mapy (przycisk "Wygeneruj załącznik").',
        },
    },
}

const zgodaOptions = [
    {
        label: 'zmianę przeznaczenia gruntów rolnych stanowiących użytki rolne klasy I-III',
        value: 'option1',
        state: 'zmiana',
    },
    {
        label: 'zmianę przeznaczenia gruntów leśnych stanowiących własność Skarbu Państwa',
        value: 'option2',
        state: 'zmiana',
    },
    {
        label: 'zmianę przeznaczenia gruntów leśnych niestanowiących własności Skarbu Państwa',
        value: 'option3',
        state: 'zmiana',
    }
]

const rodzajOptions = [
  {
    label: 'Zbiornik bezodpływowy (szambo)',
    value: 'Zbiornik bezodpływowy (szambo)',
    state: 'rodzaj',
  },
  {
    label: 'Przydomowa oczyszczalnia ścieków',
    value: 'Przydomowa oczyszczalnia ścieków',
    state: 'rodzaj',
  },
];

const dzialalnoscOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'dzialalnosc',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'dzialalnosc',
  },
];

const wodaOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'woda',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'woda',
  },
];

const umowaOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'umowa',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'umowa',
  },
];

export const przedmiotOchronyOptions = [
  {
    label: 'drzewo',
    value: 'drzewo',
    state: 'przedmiotOchrony',
  },
  {
    label: 'krzew',
    value: 'krzew',
    state: 'przedmiotOchrony',
  },
  {
    label: 'źródło',
    value: 'źródło',
    state: 'przedmiotOchrony',
  },
  {
    label: 'wodospad',
    value: 'wodospad',
    state: 'przedmiotOchrony',
  },
  {
    label: 'wywierzysko',
    value: 'wywierzysko',
    state: 'przedmiotOchrony',
  },
{
    label: 'skałka',
    value: 'skałka',
    state: 'przedmiotOchrony',
  },
  {
    label: 'jar',
    value: 'jar',
    state: 'przedmiotOchrony',
  },
  {
    label: 'głaz narzutowy',
    value: 'głaz narzutowy',
    state: 'przedmiotOchrony',
  },
  {
    label: 'jaskinia',
    value: 'jaskinia',
    state: 'przedmiotOchrony',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'przedmiotOchrony',
  },
];

export const infoDict = {
    PrzeniesienieWZ: {
        NrDecyzji: {
            label: 'Numer decyzji:',
            editable: true,
        },
        data: {
            label: 'Data wydania decyzji:',
            editable: true,
        },
        znakSprawy: {
            label: 'Znak sprawy:',
            editable: true,
        },
        nazwa: {
            label: 'Nazwa i rodzaj zamierzenia inwestycyjnego, którego dotyczy decyzja, charakterystyka inwestycji:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        adres: {
            label: 'Adres zamierzenia inwestycyjnego:',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
    },
    ZmianaWZ: {
        NrDecyzji: {
            label: 'Numer decyzji:',
            editable: true,
        },
        data: {
            label: 'Data wydania decyzji:',
            editable: true,
        },
        znakSprawy: {
            label: 'Znak sprawy:',
            editable: true,
        },
        nazwa: {
            label: 'Nazwa i rodzaj zamierzenia inwestycyjnego, którego dotyczy decyzja, charakterystyka inwestycji:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        adres: {
            label: 'Adres zamierzenia inwestycyjnego:',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
        zakres: {
            label: 'Zakres wnioskowanych zmian w decyzji o warunkach zabudowy: ',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
    },
    WnOpiniaPodzialu: {
        NrKW: {
            label: 'Numer księgi wieczystej KW:',
            editable: true,
        },
        NrDzialek: {
            label: 'Numery działek w wyniku podziału:',
            editable: true,
        },
        celPodzialu: {
            label: 'Cel dokonania podziału nieruchomości:',
            editable: true,
        },
    },
    ZgloszenieEwPOS: {
        rodzaj: {
            label: 'Rodzaj urządzenia:',
            editable: true,
            type: 'Select',
            options: rodzajOptions
        },
        adres: {
            label: 'Adres nieruchomości ze zgłaszanym urządzeniem:',
            editable: true,
        },
        liczbaOs: {
            label: 'Liczba osób zamieszkujących posesję:',
            editable: true,
        },
        dzialalnosc: {
            label: 'Czy na nieruchomości prowadzona jest zarejestrowana działalność gospodarcza:',
            editable: true,
            type: 'Select',
            options: dzialalnoscOptions
        },
        woda: {
            label: 'Czy nieruchomość zaopatrywana jest w wodę z innego źródła niż wodociąg miejski (studnia głębinowa):',
            editable: true,
            type: 'Select',
            options: wodaOptions
        },
        pojemnosc: {
            label: 'Pojemność urządzenia [m3]:',
            editable: true,
        },
        umowa: {
            label: 'Czy jest podpisana umowa z firmą asenizacyjną na opróżnianie zbiornika bezodpływowego/ osadnika i transport nieczystości ciekłych do stacji zlewnej:',
            editable: true,
            type: 'Select',
            options: umowaOptions
        },
        umowaData: {
            label: 'Data zawarcia umowy:',
            editable: true,
        },
        umowaFirma: {
            label: 'Nazwa i adres firmy świadczącej usługę opróżniania zbiorników/osadników oraz transportu nieczystości ciekłych:',
            editable: true,
            type: 'textarea',
            rows: 3
        },
        czestotliwosc: {
            label: 'Częstotliwość opróżniania:',
            editable: true,
        },
        infoDod: {
            label: 'Dodatkowe informacje (np. dotyczące współwłaścicieli, współużytkowników nieruchomości lub większej liczby zbiorników bezodpływowych):',
            editable: true,
            type: 'textarea',
            rows: 5
        },
    },
    ZgodaPrzeznaczenieGruntow: {
        zmiana: {
            label: 'Wnoszę o zgodę na:',
            editable: true,
            type: 'Select',
            options: zgodaOptions
        },
        przeznaczenie: {
            label: 'Zmiana na przeznaczenie:',
            editable: true,
        },
        uzasadnienie: {
            label: 'Uzasadnienie:',
            type: 'textarea',
            editable: true,
        },
    },
    ZaswiadczenieRewitalizacja: {
        miejscowosc: {
            label: 'Miejscowość:',
            editable: true,
        },
        cel: {
            label: 'Niniejsze zaświadczenie potrzebne jest  w celu:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
    },
    UsuniecieDrzewGminnych: {
        miejscowosc: {
            label: 'Miejscowość:',
            editable: true,
        },
        przeznaczenie: {
            label: 'Przeznaczenie terenu na którym rośnie drzewo, krzew:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        przyczyna: {
            label: 'Przyczyna zamierzonego usunięcia:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        termin: {
            label: 'Termin usunięcia:',
            editable: true,
        },
    },
}

export const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

export const bodyStyle = {
  textAlign: 'center',
  marginTop: '100px',
  marginBottom: '100px'
};

const nextStep = '/eservices/eserviceSummary/';

export const redirectToSummary = (jobId) => {
    window.location.href = `${nextStep}${jobId}`;
};

export const TEMPLATE_DECLARATION = 'template';
export const CUSTOM_DECLARATION = 'custom';
export const CUSTOM_HTML_DECLARATION = 'custom_html';

// e-services generated from the plan ogólny gminy (POG); parcels are checked against the POG border
export const POG_SERVICES = [
  'WypisIWyrysPOG',
  'WypisPOG',
  'WyrysPOG',
  'ZaswiadczeniePOG',
];
  



// WEBPACK FOOTER //
// src/routes/eservices/constants.js